import React from "react";

export default function SkeletonCard(props) {
  if (props.number === 0) {
    return (
      <div className="col-12 col-md-6 col-lg-12">
        <div className="insight-teaser image-left skeleton">
          <div className="image" />
          <div className="text">
            <p className="teaser-type insight"></p>
            <h4></h4>
          </div>
        </div>
      </div>
    );
  }
  return (
    <div className="col-12 col-md-6 col-lg-4">
      <div className="insight-teaser image-top skeleton">
        <div className="image" />
        <div className="text">
          <p className="teaser-type insight"></p>
          <h4></h4>
        </div>
      </div>
    </div>
  );
}
